import { onBeforeRouteLeave } from 'vue-router'
import type { Ref } from 'vue'
import { useConfirmDiscard } from '@/composables/useConfirmDiscard'
import { useMapModalStore } from '@/stores/mapModal'
import { useNoticeModalStore } from '@/stores/noticeModal'

export function useConfirmBeforeLeave(isDirty: Ref<boolean>) {
  const { confirmDiscard } = useConfirmDiscard()
  const mapModalStore = useMapModalStore()
  const noticeModalStore = useNoticeModalStore()

  onBeforeRouteLeave(async () => {
    // 地図モーダル開いていたら閉じる
    if (mapModalStore.visible) {
      mapModalStore.close()
    }

    // ご利用上の注意モーダルが開いていたら閉じる
    if (noticeModalStore.visible) {
      noticeModalStore.close()
    }

    if (!isDirty.value) return true
    return await confirmDiscard()
  })
}
